import { apiSlice } from './apiSlice';
import { OPENINGSTOCKS_URL } from '../constants';

export const openingStocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ------------------------------------------------------------
    // CREATE OpeningStock
    // ------------------------------------------------------------
    createOpeningStock: builder.mutation({
      query: (openingStock) => ({
        url: OPENINGSTOCKS_URL,
        method: 'POST',
        body: openingStock,
      }),
      invalidatesTags: ['OpeningStocks'],
    }),

    // ------------------------------------------------------------
    // UPDATE OpeningStock
    // ------------------------------------------------------------
    updateOpeningStock: builder.mutation({
      query: ({ openingStockId, ...data }) => ({
        url: `${OPENINGSTOCKS_URL}/${openingStockId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { openingStockId }) => [
        { type: 'OpeningStock', id: openingStockId },
        'OpeningStocks',
      ],
    }),

    // ------------------------------------------------------------
    // GET OpeningStock Details
    // ------------------------------------------------------------
    getOpeningStockDetails: builder.query({
      query: (openingStockId) => ({
        url: `${OPENINGSTOCKS_URL}/${openingStockId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, openingStockId) => [
        { type: 'OpeningStock', id: openingStockId },
      ],
    }),

    // ------------------------------------------------------------
    // GET My OpeningStocks
    // ------------------------------------------------------------
    getMyOpeningStocks: builder.query({
      query: () => ({
        url: `${OPENINGSTOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['MyOpeningStocks'],
    }),

    // ------------------------------------------------------------
    // GET All OpeningStocks (Admin)
    // ------------------------------------------------------------
    getOpeningStocks: builder.query({
      query: () => ({
        url: OPENINGSTOCKS_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['OpeningStocks'],
    }),

    // ------------------------------------------------------------
    // MARK OpeningStock as Delivered (Admin)
    // ------------------------------------------------------------
    deliverOpeningStock: builder.mutation({
      query: (openingStockId) => ({
        url: `${OPENINGSTOCKS_URL}/${openingStockId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, openingStockId) => [
        { type: 'OpeningStock', id: openingStockId },
        'OpeningStocks',
      ],
    }),

    // ------------------------------------------------------------
    // DELETE OpeningStock (Admin)
    // ------------------------------------------------------------
    deleteOpeningStock: builder.mutation({
      query: (openingStockId) => ({
        url: `${OPENINGSTOCKS_URL}/${openingStockId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, openingStockId) => [
        { type: 'OpeningStock', id: openingStockId },
        'OpeningStocks',
      ],
    }),
  }),
});

export const {
  useCreateOpeningStockMutation,
  useUpdateOpeningStockMutation,
  useGetOpeningStockDetailsQuery,
  useGetMyOpeningStocksQuery,
  useGetOpeningStocksQuery,
  useDeliverOpeningStockMutation,
  useDeleteOpeningStockMutation,
} = openingStocksApiSlice;
